export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12590.b3c10f94.jpg";